/*=========================================================================================
  File Name: moduleCountryActions.js
  Description: Country Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
 fetchTokens({ commit }) {
      return axios.get("/api/Token/GetAll").then(res => {
        commit('SET_TOKENS', res.data.Data);
      });
    },

     fetchTokenStatus({ commit }) {
      return axios.get("/api/TokenStatus/GetAll").then(res => {
        commit('SET_TOKENSTATUS', res.data.Data);
      });
    },


  fetchFilteredTokens({ commit }, filters) {

        return axios.post("/api/Token/Search", filters)
          .then((response) => {
            commit("SET_TOKENS", response.data.Data);
          })
          .catch((error) => { console.error(error); });
      },
  removeItem({ commit }, item) {
    
    return new Promise((resolve, reject) => {
      axios.delete(`API/Token/Delete/${item.Id}`, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
        .then((response) => {
          commit('REMOVE_ITEM', item.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
